import { Select, Typography } from 'antd';
import { useStoreSelection } from '@/hooks/useStoreSelection';

const { Text } = Typography;

/**
 * TCR-630: dropdown chi nhánh trong panel Thông tin đơn hàng — cùng nguồn dữ
 * liệu với header StoreSelector (pos.shiftStoreId qua useStoreSelection) nên
 * hai nơi luôn đồng bộ và store hiển thị == store gửi xuống BE.
 */
export function StoreBranchField() {
  const { stores, isLoading, currentStore, isSwitching, switchStore } = useStoreSelection();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Text style={{ fontSize: 12, color: '#555', fontWeight: 600, flexShrink: 0, width: 110 }}>
        Chi nhánh <span style={{ color: '#ff4d4f' }}>*</span>
      </Text>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Select
          data-testid="pos-branch-select"
          style={{ width: '100%' }}
          size="small"
          loading={isLoading || isSwitching}
          disabled={stores.length <= 1 || isSwitching}
          value={currentStore?.storeId}
          placeholder="Chọn chi nhánh"
          // Panel Thông tin đơn hàng hẹp (~360px) nên popup khớp bề rộng ô sẽ cắt
          // cụt tên chi nhánh dài. Cho popup tự rộng theo nội dung, chặn trên để
          // không tràn màn hình.
          popupMatchSelectWidth={false}
          dropdownStyle={{ maxWidth: 360 }}
          options={stores.map((s) => ({ value: s.storeId, label: s.name }))}
          onChange={(v) => switchStore(v)}
        />
      </div>
    </div>
  );
}
